/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Practice_Card_Audience_TrackInputs */



/**
* | output |
* | --- |
* | "Programme · {title}" |
*
* @param {Practice_Card_Audience_TrackInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_card_audience_track = /** @type {((inputs: Practice_Card_Audience_TrackInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Card_Audience_TrackInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Programma · ${i?.title}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Programme · ${i?.title}`)
	return /** @type {LocalizedString} */ (`Programme · ${i?.title}`)
});